import hasFreeSlots from './hasFreeSlots'

describe('hasFreeSlots', () => {
  describe('Когда в одном из дней есть слоты', () => {
    test('Тогда возвращается true', () => {
      expect(hasFreeSlots({
        '2026-08-17': [],
        '2026-08-18': [{ time: '10:00', duration: 1800, doctor_id: 1 }],
      })).toBe(true)
    })
  })

  describe('Когда даты есть, но все дни пустые', () => {
    test('Тогда возвращается false', () => {
      expect(hasFreeSlots({
        '2026-08-17': [],
        '2026-08-18': [],
      })).toBe(false)
    })
  })

  describe('Когда карта слотов пустая', () => {
    test('Тогда возвращается false', () => {
      expect(hasFreeSlots({})).toBe(false)
    })
  })
})
